import { imgixLoader } from '@leland-dev/leland-ui-library';
import Image from 'next/image';
import React, { type FC, useState } from 'react';

import {
  DEFAULT_COMPANY_IMAGE,
  DEFAULT_SCHOOL_IMAGE,
} from '../../utils/constants';

export enum OrganizationType {
  SCHOOL = 'SCHOOL',
  COMPANY = 'COMPANY',
}

interface OrganizationImgProps {
  nonSizeClassName?: string;
  small?: boolean;
  medium?: boolean;
  large?: boolean;
  xl?: boolean;
  pictureLink?: Possible<string>;
  name: string;
  type: OrganizationType;
}

export const OrganizationImg: FC<OrganizationImgProps> = ({
  nonSizeClassName = '',
  small,
  medium,
  large,
  xl,
  pictureLink,
  name,
  type,
}) => {
  const size = xl ? 56 : large ? 36 : !small ? 20 : 16; // corresponding to 3.5rem, 2.25rem, 1.25 rem, and 1rem
  const backupImageUrl =
    type === OrganizationType.SCHOOL
      ? DEFAULT_SCHOOL_IMAGE
      : DEFAULT_COMPANY_IMAGE;
  const [src, setSrc] = useState(
    pictureLink
      ? imgixLoader({ src: pictureLink, width: 4 * size, quality: 75 })
      : backupImageUrl,
  );

  return (
    <Image
      className={`object-contain ${nonSizeClassName} ${
        xl
          ? 'size-14'
          : large
            ? 'size-9'
            : medium
              ? 'size-6'
              : !small
                ? 'size-5'
                : 'size-4'
      }`}
      src={src}
      alt={`${name} Logo`}
      width={size}
      height={size}
      onError={() => setSrc(backupImageUrl)}
    />
  );
};
